// EventEmitter.ts
import EventEmitter from 'events'

export const eventEmitter = new EventEmitter()

export const FLOATING_OVERLAY_VISIBLE = 'FLOATING_OVERLAY_VISIBLE'
